import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FilterCriteria } from '@app/@shared/models/content-navigator/content-navigator.model';
import { PaginationParameters } from '@app/@shared/models/pagination';
import { BaseContent, CTIContentType, ReportContent, defaultCTIContentTypeFilters } from '@app/@shared/models/search/cti-search.model';
import { EntitlementService } from '@app/@shared/services/entitlement/entitlement.service';
import { SearchService } from '@app/@shared/services/search/search.service';
import { SharedModule } from '@app/@shared/shared.module';

@Component({
  selector: 'app-technology-category',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './technology-category.component.html',
  styleUrl: './technology-category.component.scss'
})
export class TechnologyCategoryComponent implements OnInit {
   contentList: Array<BaseContent>;
   count: number;
   title: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private search: SearchService,
    private entitlementService: EntitlementService) {}

  ngOnInit() {
    this.route.fragment.subscribe((fragment) => {
      this.title = fragment;
    })

    this.route.queryParams.subscribe((params) => {
      const filters = {
       [FilterCriteria.CONTENT_TYPE_LIST]: defaultCTIContentTypeFilters,
       ...this.getCategoryTagFilters(params)
      }
      this.search.getContent('', filters, new PaginationParameters(500,1)).subscribe(
        (result) => {
          this.contentList = result.contentList;
          this.count = result.count;
        }
      )
    });
  }


  public onContentClick(content: BaseContent) {
    switch (content.type) {
      case CTIContentType.BLOG:
        this.handleBlogClick(content);
        break;
      case CTIContentType.VIDEO:
        this.handleVideoClick(content);
        break;
      case CTIContentType.REPORT:
        this.navigateToAnalysisView(content as ReportContent);
    }
  }

  public navigateToAnalysisView(row: { productCode: string}, activeTab?: string): void {
    const fragment = new URLSearchParams();
    activeTab && fragment.set('activeTab', activeTab);
    this.router.navigate(['search', 'analysis-view', row.productCode], {
      fragment: fragment.toString(),
    });
  }

  private handleBlogClick(blog: BaseContent) {
    if(blog.entitled) {
      this.router.navigate(['search', ...blog.contentUrl]);
    } else {
      this.entitlementService.openRequestAccessConfirmDialog(`TechStream: ${blog.subscriptionName}: ${blog.name}`);
    }
  }

  private handleVideoClick(video: BaseContent) {
    if (video.entitled) {
      const fragment = `subscription=${encodeURIComponent(video.subscriptionName || video.chanelName)}&name=${video.name}}`;
      this.router.navigate(['search', ...video.contentUrl], { fragment });
    } else {
      const videoTitle = `Video: ${video.chanelName}: ${video.name}`;
      this.entitlementService.openRequestAccessConfirmDialog(videoTitle);
    }
  }

  private getCategoryTagFilters(params: Params) {
    const filteredParams = Object.entries(params)
    .filter(e => ['technologyTag', 'contentTag', 'themeTag', 'segmentTag'].includes(e[0]));
    return filteredParams.reduce((acc, value) => ({
      ...acc,
      [value[0]]: value[1].split(',')
    }), {})
  }

}
